import React from 'react';

import PhotoPage from '../components/photoPage/PhotoPage';
import PhotoGalleries from '../config/PhotoGalleries';

export default () => {
    return PhotoPage(PhotoGalleries.PROVOZOVNA);
};
